module.exports = __webpack_public_path__ + "img/step4.927976c5.png";